<onyx-modal
  variant="right"
  heading="labels.vehicleAndDriverHistory"
  [loading]="loading()"
  [(error)]="error"
  (errorChange)="activity$.next()"
  (closeModal)="dialogRef.close()"
>
  <div class="container">
    @for (point of points(); track point) {
      <section>
        <ng-container
          *ngTemplateOutlet="
            headingTemplate;
            context: {
              icon: MapHelper.getPointIconByType(point.point.type),
              color: point.iconColor,
              title: `${DictionaryCode.ORDER_POINT_TYPE}.${point.point.type}`,
              date: point.point.timestamps.completedAt,
            }
          "
        ></ng-container>

        <onyx-information-list>
          <ng-container
            [ngTemplateOutlet]="sharedFieldsTemplate"
            [ngTemplateOutletContext]="{
              orderPreview: !order() ? point.order : null,
              vehicle: point.vehicle,
              trailer: point.trailer,
              primaryDriver: point.drivers.primary,
              secondaryDriver: point.drivers.secondary,
              address: 'address' in point.point ? point.point.address : null,
            }"
          ></ng-container>
        </onyx-information-list>
      </section>
    }

    @if (order(); as order) {
      @if (assignmentState(); as state) {
        <section>
          <ng-container
            *ngTemplateOutlet="
              headingTemplate;
              context: {
                icon: state.icon,
                color: state.color,
                title: state.title,
                date: order.timestamps.toDoAt,
              }
            "
          ></ng-container>

          @if (order.outsourcingData; as outsourcingData) {
            <onyx-information-list>
              @if (
                outsourcingData.vehicleRegistrationNumber;
                as registrationNumber
              ) {
                <onyx-information-row label="labels.vehicle">
                  {{ registrationNumber | fleetIdentifier }}
                </onyx-information-row>
              }

              <onyx-information-row label="labels.semiTrailerOrTrailer">
                {{
                  outsourcingData.trailerRegistrationNumber | fleetIdentifier
                }}
              </onyx-information-row>

              @if (outsourcingData.primaryDriver; as primaryDriver) {
                @let secondaryDriver = outsourcingData.secondaryDriver;

                <onyx-information-row
                  [label]="`labels.${secondaryDriver ? 'drivers' : 'driver'}`"
                >
                  <p>
                    {{ primaryDriver.name }}

                    @if (secondaryDriver) {
                      <br />

                      {{ secondaryDriver.name }}
                    }
                  </p>
                </onyx-information-row>
              }

              @if (outsourcingData.author; as author) {
                <ng-container
                  *ngTemplateOutlet="authorRowTemplate; context: { author }"
                ></ng-container>
              }
            </onyx-information-list>
          }

          @if (order.assignedData; as assignedData) {
            <onyx-information-list>
              <ng-container
                *ngTemplateOutlet="
                  sharedFieldsTemplate;
                  context: {
                    vehicle: assignedData.vehicle,
                    trailer: assignedData.trailer,
                    primaryDriver: assignedData.primaryDriver,
                    secondaryDriver: assignedData.secondaryDriver,
                    emptyDistance: assignedData.emptyDistance,
                  }
                "
              ></ng-container>

              @if (acceptedProposal()?.acceptance?.author; as author) {
                <ng-container
                  *ngTemplateOutlet="authorRowTemplate; context: { author }"
                ></ng-container>
              }
            </onyx-information-list>
          }
        </section>
      }

      @for (proposal of proposals(); track proposal.uuid) {
        <section>
          <ng-container
            *ngTemplateOutlet="
              headingTemplate;
              context: {
                icon: proposal.icon,
                color: proposal.color,
                title: proposal.title,
                date: proposal.date,
              }
            "
          ></ng-container>

          <onyx-information-list>
            <ng-container
              [ngTemplateOutlet]="sharedFieldsTemplate"
              [ngTemplateOutletContext]="{
                vehicle: proposal.vehicle,
                trailer: proposal.trailer,
                primaryDriver: proposal.primaryDriver,
                secondaryDriver: proposal.secondaryDriver,
                emptyDistance: proposal.result?.emptyDistance,
              }"
            ></ng-container>

            @if (proposal.reason; as reason) {
              <onyx-information-row label="labels.reason">
                {{ reason | translate }}
              </onyx-information-row>
            }

            @if (proposal.author; as author) {
              <ng-container
                *ngTemplateOutlet="
                  authorRowTemplate;
                  context: { author, label: proposal.authorLabel }
                "
              ></ng-container>
            }
          </onyx-information-list>
        </section>
      }
    }

    @if (
      !points().length &&
      !proposals().length &&
      !order()?.assignedData &&
      !order()?.outsourcingData
    ) {
      <div class="empty">
        <div class="wrapper">
          <onyx-icon name="history-outlined" [size]="32"></onyx-icon>

          <p class="f-paragraph-l f-medium">
            {{ `${I18N}.noHistory` | translate }}
          </p>
        </div>
      </div>
    }
  </div>
</onyx-modal>

<ng-template
  let-icon="icon"
  let-color="color"
  let-title="title"
  let-date="date"
  #headingTemplate
>
  <onyx-information-heading>
    <ng-container titleIcon>
      <onyx-icon
        class="{{ color ?? '' }}"
        [name]="icon"
        [size]="20"
      ></onyx-icon>
    </ng-container>

    {{ title | translate }}

    <ng-container actions>
      {{ date | onyxDate: 'time-date' : { separator: ' · ' } }}
    </ng-container>
  </onyx-information-heading>
</ng-template>

<ng-template let-author="author" let-label="label" #authorRowTemplate>
  <onyx-information-row [label]="label || 'labels.author'">
    <onyx-link
      color="black"
      font="f-body-m f-medium"
      (click)="employeeHelper.openModal(author)"
    >
      {{ author | onyxName }}
    </onyx-link>
  </onyx-information-row>
</ng-template>

<ng-template
  let-orderPreview="orderPreview"
  let-vehicle="vehicle"
  let-trailer="trailer"
  let-primaryDriver="primaryDriver"
  let-secondaryDriver="secondaryDriver"
  let-emptyDistance="emptyDistance"
  let-address="address"
  #sharedFieldsTemplate
>
  @if (orderPreview) {
    <onyx-information-row label="labels.orderId">
      <onyx-link
        color="black"
        font="f-body-m f-medium"
        (click)="orderHelper.openModal(orderPreview.uuid)"
      >
        {{ orderPreview.identifier }}
      </onyx-link>
    </onyx-information-row>
  }

  <onyx-information-row label="labels.vehicle">
    <app-module-link
      module="fleet"
      color="black"
      font="f-body-m f-medium"
      (linkClick)="fleetHelper.openModal(vehicle)"
    >
      {{ vehicle?.generalInformation | fleetIdentifier }}
    </app-module-link>
  </onyx-information-row>

  <onyx-information-row
    [label]="
      !trailer && !vehicle
        ? 'labels.semiTrailerOrTrailer'
        : vehicle?.generalInformation.category === FleetCategory.SEMI_TRUCK ||
            trailer?.generalInformation.category === FleetCategory.SEMI_TRAILER
          ? 'labels.semiTrailer'
          : 'labels.trailer'
    "
  >
    <app-module-link
      module="fleet"
      color="black"
      font="f-body-m f-medium"
      (linkClick)="fleetHelper.openModal(trailer)"
    >
      {{ trailer?.generalInformation | fleetIdentifier }}
    </app-module-link>
  </onyx-information-row>

  @if (primaryDriver?.driverData; as primaryDriverData) {
    @let secondaryDriverData = secondaryDriver?.driverData;

    <onyx-information-row
      [label]="`labels.${secondaryDriverData ? 'drivers' : 'driver'}`"
    >
      <div>
        <app-module-link
          module="drivers"
          color="black"
          font="f-body-m f-medium"
          (linkClick)="driverHelper.openModal(primaryDriver)"
        >
          {{ primaryDriverData | onyxName }}
        </app-module-link>

        @if (secondaryDriverData) {
          <br />

          <app-module-link
            module="drivers"
            color="black"
            font="f-body-m f-medium"
            (linkClick)="driverHelper.openModal(secondaryDriver)"
          >
            {{ secondaryDriverData | onyxName }}
          </app-module-link>
        }
      </div>
    </onyx-information-row>
  }

  @if (emptyDistance != null) {
    <onyx-information-row label="labels.emptyKm">
      <app-unit-cell
        [value]="emptyDistance"
        [decimalPlaces]="3"
        unit="km"
      ></app-unit-cell>
    </onyx-information-row>
  }

  @if (address) {
    <onyx-information-row label="labels.address">
      <onyx-address [address]="address" format="full"></onyx-address>
    </onyx-information-row>
  }
</ng-template>
